export default "__VITE_ASSET__Djy1Qnbq__"